// Bridge to the GoChat Passkey Bridge browser extension (tools/passkey-extension).
// The extension signs WhatsApp linking challenges (rpId: whatsapp.com) with the
// user's passkey inside the web.whatsapp.com tab. Stable extension id is pinned
// by the `key` field of its manifest.

const PASSKEY_EXTENSION_ID = 'ebdjeglbpicgepikccllfchbeojanpob';

interface ChromeExternalRuntime {
  runtime: { sendMessage: (extensionId: string, message: unknown) => Promise<unknown> };
}

export interface TPasskeyAssertion {
  id?: string;
  rawId?: string;
  type?: string;
  response?: {
    clientDataJSON?: string;
    authenticatorData?: string;
    signature?: string;
    userHandle?: string | null;
  };
}

type BridgeResponse = { ok: true; version?: string } | { ok: true; requestId?: string; assertion: TPasskeyAssertion } | { ok?: false; error?: string };

const externalRuntime = (): ChromeExternalRuntime | null => {
  const chromeApi = (window as unknown as { chrome?: ChromeExternalRuntime }).chrome;
  return chromeApi?.runtime?.sendMessage ? chromeApi : null;
};

export const isPasskeyBridgeAvailable = (): boolean => externalRuntime() !== null;

export async function pingPasskeyBridge(): Promise<boolean> {
  const runtime = externalRuntime();
  if (!runtime) return false;
  try {
    const res = (await runtime.runtime.sendMessage(PASSKEY_EXTENSION_ID, { type: 'GOCHAT_PASSKEY_PING' })) as BridgeResponse;
    return !!res?.ok;
  } catch {
    return false;
  }
}

export async function signPasskeyChallenge(requestId: string, requestOptions: unknown): Promise<TPasskeyAssertion> {
  const runtime = externalRuntime();
  if (!runtime) throw new Error('passkey_bridge_unavailable');
  const res = (await runtime.runtime.sendMessage(PASSKEY_EXTENSION_ID, {
    type: 'GOCHAT_PASSKEY_SIGN',
    requestId,
    requestOptions,
  })) as BridgeResponse;
  if (!res?.ok || !('assertion' in res) || !res.assertion?.response) {
    throw new Error('passkey_sign_failed' in (res as object) ? 'passkey_sign_failed' : ((res as { error?: string }).error ?? 'passkey_sign_failed'));
  }
  return res.assertion;
}
